function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "debateTitle"
}, "debate");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "11 172.702359 168.702359 172.702359 168.702359 15 11 15"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-1154.000000, -1064.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Detailed_Icon_Debate",
  transform: "translate(1154.000000, 1064.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-20",
  x: 0,
  y: 0,
  width: 180,
  height: 180
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.535944,135.017134 C104.535944,137.916211 102.185416,140.267296 99.2857824,140.267296 C96.3872613,140.267296 94.0367331,137.916211 94.0367331,135.017134 C94.0367331,132.1175 96.3872613,129.766972 99.2857824,129.766972 C102.185416,129.766972 104.535944,132.1175 104.535944,135.017134",
  id: "Fill-1",
  fill: "#4F4978"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.379741,135.017134 C146.379741,137.916211 144.029213,140.267296 141.130135,140.267296 C138.231058,140.267296 135.88053,137.916211 135.88053,135.017134 C135.88053,132.1175 138.231058,129.766972 141.130135,129.766972 C144.029213,129.766972 146.379741,132.1175 146.379741,135.017134",
  id: "Fill-3",
  fill: "#4F4978"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.773103,56.6769507 C113.773103,47.5997394 119.457208,39.8683099 127.451786,36.7939859 C125.077335,35.8815915 122.508723,35.3597465 119.812708,35.3597465 C108.040039,35.3597465 98.4960606,44.9042817 98.4960606,56.6769507 C98.4960606,68.4501761 108.040039,77.9941549 119.812708,77.9941549 C122.508723,77.9941549 125.077335,77.4728662 127.451786,76.5599155 C119.457208,73.4861479 113.773103,65.754162 113.773103,56.6769507",
  id: "Fill-5",
  fill: "#716990"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.130413,56.6769507 C141.130413,47.5997394 135.446308,39.8683099 127.45173,36.7939859 C119.457153,39.8683099 113.773047,47.5997394 113.773047,56.6769507 C113.773047,65.754162 119.457153,73.4861479 127.45173,76.5599155 C135.446308,73.4861479 141.130413,65.754162 141.130413,56.6769507",
  id: "Fill-7",
  fill: "#716990"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-10"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  fill: "#403C6C",
  mask: "url(#mask-2)",
  points: "108.547754 144.432599 131.715338 144.432599 131.715338 109.318768 108.547754 109.318768"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.012463,84.2423317 C127.761555,84.165557 127.516766,84.0726486 127.26252,84.0031063 L123.8989,87.3667261 L119.813154,91.4524725 L115.727407,87.3667261 L112.576308,84.2156275 L112.576308,87.9419796 L112.576308,109.318712 L128.012463,109.318712 L128.012463,87.9419796 L128.012463,84.2423317 Z",
  id: "Fill-11",
  fill: "#E8E6EE",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.012463,84.2156831 L128.012463,84.2423873 C128.021365,84.245169 128.029154,84.2479507 128.038055,84.2507324 L128.012463,84.2156831 Z",
  id: "Fill-12",
  fill: "#403C6C",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.692458,51.4227275 C125.389218,50.0318824 122.69988,49.2157345 119.813042,49.2157345 C111.37562,49.2157345 104.536,56.0559106 104.536,64.4933331 C104.536,71.5132063 109.276556,77.4126148 115.727296,79.2012415 L115.727296,83.4650162 C114.653563,83.6530585 113.600972,83.9006289 112.576197,84.2155162 L115.727296,87.3666148 L119.813042,91.4523613 L123.899345,87.3666148 L127.262965,84.0029951 C126.168092,83.7020162 125.045401,83.4711359 123.899345,83.3131359 L123.899345,79.2068049 C125.246796,78.8296077 126.520254,78.272157 127.692458,77.5639387 C132.120352,74.8885092 135.090641,70.0444739 135.090641,64.4933331 C135.090641,58.9427486 132.120352,54.098157 127.692458,51.4227275",
  id: "Fill-13",
  fill: "#4F4978",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.0236592,109.318545 L94.0236592,135.016911 L98.4832648,135.016911 C98.4832648,140.217003 102.698638,144.432376 107.898173,144.432376 L112.563624,144.432376 L112.563624,109.318545 L112.563624,87.942369 L112.563624,84.2154606 C101.828525,87.5123197 94.0236592,97.5024817 94.0236592,109.318545",
  id: "Fill-14",
  fill: "#5F5984",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.565001,109.318545 L146.565001,135.016911 L142.105396,135.016911 C142.105396,140.217003 137.890023,144.432376 132.690487,144.432376 L128.025037,144.432376 L128.025037,109.318545 L128.025037,87.942369 L128.025037,84.2154606 C138.760135,87.5123197 146.565001,97.5024817 146.565001,109.318545",
  id: "Fill-15",
  fill: "#5F5984",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.1405444,52.1292768 C56.1405444,45.9861923 59.9870655,40.7543894 65.3974528,38.6736852 C63.7907486,38.05615 62.0521923,37.7034317 60.2279599,37.7034317 C52.260643,37.7034317 45.8021148,44.1625162 45.8021148,52.1292768 C45.8021148,60.09715 52.260643,66.5556782 60.2279599,66.5556782 C62.0521923,66.5556782 63.7907486,66.2029599 65.3974528,65.5854246 C59.9870655,63.5047204 56.1405444,58.2723613 56.1405444,52.1292768",
  id: "Fill-16",
  fill: "#4F4978",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.65425,52.1292768 C74.65425,45.9861923 70.8077289,40.7543894 65.3973415,38.6736852 C59.9869542,40.7543894 56.1404331,45.9861923 56.1404331,52.1292768 C56.1404331,58.2723613 59.9869542,63.5047204 65.3973415,65.5854246 C70.8077289,63.5047204 74.65425,58.2723613 74.65425,52.1292768",
  id: "Fill-17",
  fill: "#4F4978",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-18",
  fill: "#403C6C",
  mask: "url(#mask-2)",
  points: "48.758662 144.199493 71.9190141 144.199493 71.9190141 109.836718 48.758662 109.836718"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-19",
  fill: "#403C6C",
  mask: "url(#mask-2)",
  points: "60.2158873 144.199493 71.9195704 144.199493 71.9195704 109.836718 60.2158873 109.836718"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.2169965,136.956139 C44.2169965,140.015998 41.7368415,142.496153 38.6769824,142.496153 C35.6171232,142.496153 33.1369683,140.015998 33.1369683,136.956139 C33.1369683,133.896836 35.6171232,131.416681 38.6769824,131.416681 C41.7368415,131.416681 44.2169965,133.896836 44.2169965,136.956139",
  id: "Fill-20",
  fill: "#716990",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.540207,136.956139 C87.540207,140.015998 85.0600521,142.496153 82.000193,142.496153 C78.9403338,142.496153 76.4601789,140.015998 76.4601789,136.956139 C76.4601789,133.896836 78.9403338,131.416681 82.000193,131.416681 C85.0600521,131.416681 87.540207,133.896836 87.540207,136.956139",
  id: "Fill-21",
  fill: "#716990",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.0272739,78.0546845 L56.0272739,82.5537901 C54.8945697,82.7524028 53.7830063,83.0138817 52.7020415,83.3460155 L56.0272739,86.6712479 L60.3388937,90.9828676 L64.6505134,86.6712479 L68.2005063,83.1218113 C67.0455486,82.8041423 65.8605486,82.5604662 64.6505134,82.3941211 L64.6505134,78.0608042",
  id: "Fill-22",
  fill: "#4E4877",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9914521,83.3461268 L68.9914521,83.3745 C69.0003535,83.3772817 69.0092549,83.3806197 69.0187127,83.3828451 L68.9914521,83.3461268 Z",
  id: "Fill-23",
  fill: "#403C6C",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-24",
  fill: "#E8E6EE",
  mask: "url(#mask-2)",
  points: "51.9364648 129.504937 68.7423239 129.504937 68.7423239 75.5624014 51.9364648 75.5624014"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-25",
  fill: "#403C6C",
  mask: "url(#mask-2)",
  points: "60.2790873 87.4496761 65.815207 78.9961197 54.7424113 78.9961197"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-26",
  fill: "#403C6C",
  mask: "url(#mask-2)",
  points: "65.8153183 119.668936 65.8053042 119.668936 60.2791986 78.9961754 54.7525366 119.668936 54.7425225 119.668936 60.2791986 125.129394"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.2920761,75.562012 L41.4089915,83.1843993 C36.2979141,86.7638782 33.1373577,93.4788782 33.1373577,100.758005 L33.1373577,136.683533 L42.4092873,136.683533 C42.4092873,140.834927 45.1225479,144.19966 48.4700338,144.19966 L52.2920761,144.19966 L52.2920761,75.562012 Z",
  id: "Fill-27",
  fill: "#4F4978",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.1998387,75.5622901 L79.1880711,83.1841211 C84.3486627,86.7641563 87.5403739,93.4791563 87.5403739,100.757727 L87.5403739,136.683255 L78.1788739,136.683255 C78.1788739,140.834649 75.4389092,144.199382 72.0591556,144.199382 L68.1998387,144.199382 L68.1998387,75.5622901 Z",
  id: "Fill-28",
  fill: "#4F4978",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-29",
  fill: "#E8E6EE",
  mask: "url(#mask-2)",
  points: "60.2790873 78.0546845 57.1430099 82.8964944 52.2922986 76.2738465"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-30",
  fill: "#E8E6EE",
  mask: "url(#mask-2)",
  points: "60.2790873 78.0546845 63.4151648 82.8964944 68.2658761 76.2738465"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.0420225,60.2168183 C50.0420225,61.8591282 48.7107056,63.1898887 47.0683958,63.1898887 C45.4266423,63.1898887 44.0953254,61.8591282 44.0953254,60.2168183 C44.0953254,58.5745085 45.4266423,57.2431915 47.0683958,57.2431915 C48.7107056,57.2431915 50.0420225,58.5745085 50.0420225,60.2168183",
  id: "Fill-31",
  fill: "#716990",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.5826845,60.2168183 C76.5826845,61.8591282 75.2513676,63.1898887 73.6090577,63.1898887 C71.9673042,63.1898887 70.6359873,61.8591282 70.6359873,60.2168183 C70.6359873,58.5745085 71.9673042,57.2431915 73.6090577,57.2431915 C75.2513676,57.2431915 76.5826845,58.5745085 76.5826845,60.2168183",
  id: "Fill-32",
  fill: "#716990",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.5144246,53.1770282 C73.4966218,53.0223662 73.4682486,52.8727113 73.4448824,52.7197183 C73.3914739,52.3675563 73.3286077,52.0192887 73.2479387,51.6760282 C73.2106641,51.5152465 73.1689387,51.3561338 73.124988,51.1975775 C73.0309669,50.8537606 72.922481,50.5166197 72.802312,50.1844859 C72.7544669,50.0548592 72.7105162,49.923007 72.6587768,49.794493 C72.487981,49.3655563 72.2982697,48.9471901 72.0851923,48.5416197 C72.0740655,48.5215915 72.0657204,48.499338 72.0540373,48.4781972 C71.8109176,48.022 71.5410937,47.5836056 71.2484599,47.1607887 C71.2356641,47.1429859 71.2211993,47.1268521 71.2089599,47.1079366 C70.9369106,46.720169 70.6420514,46.3496479 70.3310585,45.9935915 C70.279319,45.933507 70.2253542,45.8767606 70.1725021,45.8183451 C69.88265,45.4978944 69.5777768,45.1924648 69.2584387,44.9015 C69.2055866,44.8542113 69.1538472,44.8052535 69.0998824,44.7574085 C68.732143,44.4336197 68.3499387,44.1265211 67.9477063,43.8439014 C67.9465937,43.8439014 67.9460373,43.8433451 67.9449246,43.8422324 L67.9449246,43.8422324 C65.7896711,42.3312183 63.170988,41.4360704 60.3386711,41.4360704 C53.0100303,41.4360704 47.0688965,47.3777606 47.0688965,54.7075141 L47.0688965,65.7263451 C47.0688965,73.0549859 53.0100303,78.9961197 60.3386711,78.9961197 C63.170988,78.9961197 65.7902275,78.1026408 67.9449246,76.5910704 C67.9465937,76.5905141 67.9482627,76.5888451 67.9499317,76.5877324 C68.3516077,76.3051127 68.733812,75.9991268 69.1009951,75.6742254 C69.1544035,75.6280493 69.2050303,75.5807606 69.2573261,75.5329155 C69.5777768,75.2413944 69.8832063,74.9348521 70.1736148,74.6138451 C70.2259106,74.5559859 70.279319,74.4992394 70.3310585,74.4402676 C70.6437204,74.0814296 70.9402486,73.7097958 71.2139669,73.3192465 C71.2245373,73.303669 71.2362204,73.2897606 71.2467908,73.2741831 C71.5405373,72.8508099 71.8114739,72.4113028 72.05515,71.9534366 C72.0651641,71.9350775 72.0729528,71.9150493 72.0829669,71.8961338 C72.297157,71.4888944 72.487981,71.0688592 72.6593331,70.6382535 C72.7105162,70.5102958 72.7544669,70.3795563 72.8017556,70.2499296 C72.922481,69.9172394 73.0309669,69.5795423 73.1255444,69.2346127 C73.1689387,69.0766127 73.2106641,68.9180563 73.2479387,68.7572746 C73.3286077,68.4145704 73.3914739,68.0657465 73.4448824,67.7124718 C73.4682486,67.5605915 73.4966218,67.4098239 73.5144246,67.256831 C73.5722838,66.7533451 73.6095585,66.2448521 73.6095585,65.7263451 L73.6095585,54.7075141 C73.6095585,54.1884507 73.5722838,53.6794014 73.5144246,53.1770282",
  id: "Fill-33",
  fill: "#716990",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.7207493,48.1053394 C57.9825239,43.7709099 61.2187423,40.2810014 65.3973972,38.6737408 C63.790693,38.0562056 62.0521366,37.702931 60.2279042,37.702931 C56.9293761,37.702931 53.8995592,38.8222831 51.4694746,40.6849028 C51.7092563,44.0156986 53.7983056,46.830769 56.7207493,48.1053394",
  id: "Fill-34",
  fill: "#4F4978",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.7207493,48.1053394 C57.7955944,48.5737761 58.9805944,48.8374803 60.2279042,48.8374803 C64.8660944,48.8374803 68.6564254,45.2424239 68.9857775,40.6887972 C67.8998056,39.8576282 66.6953338,39.1727761 65.3973972,38.6737408 C61.2187423,40.2810014 57.9825239,43.7709099 56.7207493,48.1053394",
  id: "Fill-35",
  fill: "#4F4978",
  mask: "url(#mask-2)"
}))));

var SvgDetailedIconDebate = function SvgDetailedIconDebate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    "aria-labelledby": "debateTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "debateTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetailedIconDebate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/detailed-icon-debate.4e39ab06.svg";
export { ForwardRef as ReactComponent };